import TagSkeleton from './TagSkeleton';

export default TagSkeleton;
